import './userList.scss';
import UserListController from './userListController';

const UserListComponent = {
    template: require('./userListView.html'),
    controller: UserListController
};

export default UserListComponent;


// WEBPACK FOOTER //
// ./src/app/pages/user/list/userListComponent.js